import { useQuery } from "@faire/web-api--source/api/logged-out-homepage/category-brands-banner/get-hooks";
export var useCategoryBrandsBannerQuery = function() {
    var _useQuery = useQuery({
        gcTime: Infinity,
        staleTime: Infinity
    }), data = _useQuery.data, dataUpdatedAt = _useQuery.dataUpdatedAt, isFetching = _useQuery.isFetching;
    return {
        categoryBestBrands: data === null || data === void 0 ? void 0 : data.category_brands_carousels,
        dataUpdatedAt: dataUpdatedAt,
        isFetching: isFetching
    };
};
